import React from 'react';
import { Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import WhiteContainer from '../../../../components/containers/WhiteContainer';
import List from '../../../../components/list/List';
import text, { formatCurrency } from '../../../../text';
import { isMembershipPriceId } from '../../../../utilities/membership';
import { userHasActiveMembership } from '../../../../utilities/user';
import ChargeItem from '../../../billing/Invoice/ChargeItem';
import T from 'prop-types';
var RfqCard = function(param) {
    var index = param.index, order = param.order, quote = param.quote, _param_siteDeploymentFee = param.siteDeploymentFee, siteDeploymentFee = _param_siteDeploymentFee === void 0 ? null : _param_siteDeploymentFee;
    var currency = quote.currency;
    var _useSelector = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile,
            membershipPriceId: state.order.membershipPriceId
        };
    }), currentUser = _useSelector.currentUser, membershipPriceId = _useSelector.membershipPriceId;
    return /*#__PURE__*/ React.createElement(Col, {
        className: "px-0 mt-2 quote-card",
        key: index
    }, /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "p-3 charge-item"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "title mb-2"
    }, index + 1, ". ", order.header), /*#__PURE__*/ React.createElement("div", {
        className: "px-3"
    }, /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "is-borderless"
    }, order.data.map(function(param, index) {
        var discounts = param.discounts, details = param.details, price = param.price, fees = param.fees, member_discounts_preview = param.member_discounts_preview;
        return /*#__PURE__*/ React.createElement(ChargeItem, {
            key: index,
            displayName: text("".concat(details.category_name, "3D")),
            discounts: isMembershipPriceId(membershipPriceId) ? member_discounts_preview : discounts,
            details: details,
            price: price,
            fees: fees,
            quote: quote,
            isIndividualDiscountVisible: !userHasActiveMembership(currentUser) && !isMembershipPriceId(membershipPriceId),
            isApproximate: true,
            areaIsAlignedMiddle: true
        });
    }), siteDeploymentFee ? /*#__PURE__*/ React.createElement(List.Item, {
        className: "charge",
        description: text('siteDeploymentFee'),
        value: "~".concat(isNaN(siteDeploymentFee) ? siteDeploymentFee : formatCurrency(siteDeploymentFee, currency.name, currency.scale_factor, {}, true)),
        midText: /*#__PURE__*/ React.createElement("span", null)
    }) : null))));
};
RfqCard.propTypes = {
    index: T.number,
    order: T.object,
    quote: T.object,
    siteDeploymentFee: T.oneOfType([
        T.string,
        T.number,
        null
    ])
};
export default RfqCard;
